export default "__VITE_ASSET__3HQ1yATG__"